import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { ChipsTransactionHistoryDto } from '@core/dtos'
import { PlayerHttp } from '@core/https'
import { CamelCaseToTitlePipe, ChipsTransactionTypeIconPipe } from '@shared/pipes'
import { SvgIconComponent } from 'angular-svg-icon'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { ChipsTransactionTypeEnum } from '@core/enums'

@Component({
  selector: 'app-coin',
  standalone: true,
  imports: [
    SvgIconComponent,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    ChipsTransactionTypeIconPipe,
    CamelCaseToTitlePipe,
  ],
  templateUrl: './coin.component.html',
  styleUrl: './coin.component.sass',
})
export class CoinComponent implements OnInit {
  constructor(private _playerHttp: PlayerHttp) {}

  chipsHistories: ChipsTransactionHistoryDto[] = []
  filteredChipHistories: ChipsTransactionHistoryDto[] = []

  chipHistoryTypes = ChipsTransactionTypeEnum
  selectedDate: string = new Date().toLocaleDateString()
  selectedType: ChipsTransactionTypeEnum = ChipsTransactionTypeEnum.ALL

  datePicker = new FormGroup({
    start: new FormControl(new Date()),
    end: new FormControl(new Date()),
  })

  ngOnInit(): void {
    this._playerHttp.chipTransactionHistories().subscribe((histories) => {
      this.chipsHistories = histories.map((i) => ({
        ...i,
      }))

      const startDate = this.normalizeDate(this.datePicker.value.start as Date)
      const endDate = this.normalizeDate(this.datePicker.value.end as Date)

      this.filteredChipHistories = this.chipsHistories.filter((chipHistory) => {
        const chipDate = this.normalizeDate(new Date(chipHistory.transactionDate))

        return chipDate >= startDate && chipDate <= endDate
      })
    })
  }

  normalizeDate(date: Date): Date {
    if (!date) {
      return new Date()
    }

    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
  }

  private getHistoryIcon(type: ChipsTransactionTypeEnum): string {
    const svgPath = 'assets/svg/icons'
    switch (type) {
      case ChipsTransactionTypeEnum.WIN:
      case ChipsTransactionTypeEnum.RUSH_TOTAL_WIN:
        return `${svgPath}/Star.svg`
      case ChipsTransactionTypeEnum.BUYIN:
        return `${svgPath}/PokerChip.svg`
      case ChipsTransactionTypeEnum.DEPOSIT:
        return `${svgPath}/CreditCard.svg`
      case ChipsTransactionTypeEnum.LOSE:
      case ChipsTransactionTypeEnum.RUSH_TOTAL_LOSS:
        return `${svgPath}/ArrowCircleDown.svg`
      case ChipsTransactionTypeEnum.CLASSIC_BET:
      case ChipsTransactionTypeEnum.RUSH_CALL_BETS:
      case ChipsTransactionTypeEnum.RUSH_PAIR_BETS:
      case ChipsTransactionTypeEnum.RUSH_TRIO_BETS:
        return `${svgPath}/PokerChip.svg`
      default:
        return ''
    }
  }

  getActionType(type: ChipsTransactionTypeEnum): string {
    switch (type) {
      case ChipsTransactionTypeEnum.WIN:
        return 'Credited '
      case ChipsTransactionTypeEnum.BUYIN:
        return 'Buy In '
      case ChipsTransactionTypeEnum.DEPOSIT:
        return 'Deposited '
      case ChipsTransactionTypeEnum.LOSE:
        return `Loss `
      case ChipsTransactionTypeEnum.CLASSIC_BET:
        return 'Betted '
      case ChipsTransactionTypeEnum.RUSH_CALL_BETS:
        return 'Rush Betted Call '
      case ChipsTransactionTypeEnum.RUSH_PAIR_BETS:
        return 'Rush Betted Pair '
      case ChipsTransactionTypeEnum.RUSH_TRIO_BETS:
        return 'Rush Betted Trio '
      case ChipsTransactionTypeEnum.RUSH_TOTAL_WIN:
        return 'Rush Credited '
      case ChipsTransactionTypeEnum.RUSH_TOTAL_LOSS:
        return `Rush Loss `
      default:
        return ''
    }
  }

  getFontColor(isDeduct: boolean): string {
    return isDeduct ? 'text-red-500' : 'text-green-600'
  }

  filterChipsHistories() {
    const startDate = this.normalizeDate(this.datePicker.value.start as Date)
    const endDate = this.normalizeDate(this.datePicker.value.end as Date)

    this.filteredChipHistories = this.chipsHistories
      .filter((chipHistory) => {
        const chipDate = this.normalizeDate(new Date(chipHistory.transactionDate))

        return chipDate >= startDate && chipDate <= endDate
      })
      .filter((chipHistory) => {
        if (this.selectedType === this.chipHistoryTypes.ALL) {
          return true
        }

        return chipHistory.type === this.selectedType
      })
  }
}
